﻿import { WizardButtons } from '../../Wizard/WizardButtons';
import { Alert } from '@mui/material';

const SentConfirmationForCVL = (props) => {
  return (
    <>
      <Alert severity="success">
        The Cash Value Letter has been requested and will be mailed to the Owner's address on record
        and may take 5-10 business days to receive.
      </Alert>
      <WizardButtons {...props} executeComplete={props.executeComplete} />
    </>
  );
};

export { SentConfirmationForCVL };
